<template>
  <!--:class="!!shadeShow?'show-shade':'hide-shade'" -->
    <div class="shade-style" v-pop-level @keydown="buttonOne($event)" tabindex="0" >
      <input class="get-focus-input" :style="{position:'fixed',top:'-100px'}" id="focusInput"/>
      <div class="dialog-pop-win-div"
           :class="!!dialogShow?'show-scale':'hide-scale'"
           :style="{position:'fixed',left:mouseObj.popX,top:mouseObj.popY}"
           v-drag
        >
          <div class="dialog-head-div"
               id="moveZone"
          >
            <span style="color: #666666;" v-html="dialogHead"></span>
            <i class="fa fa-close close-size close-button"
               @click="closeDialog"
               v-key-alt-x="closeDialog"
               v-key-esc="closeDialog"
            ></i>
          </div>
          <div class="dialog-content-div">
            <div style="width: 100%;word-break: break-all" v-html="dialogDisplayContent"></div>
          </div>
          <div class="dialog-button-div">
            <button-style-component
              @clickCallBack="buttonOne"
              buttonType="emptyBlue"
              buttonStyle="width:80px,borderRadius:10px,padding:0 10px;themeColor:#4b8fe2"
              v-if="buttonOne"
            >
              <span>{{buttonOneValue}}</span>
            </button-style-component>

            <button-style-component
              @clickCallBack="buttonTwo"
              buttonType="fullBlue"
              buttonStyle="width:80px,borderRadius:10px,padding:0 10px;themeColor:#4b8fe2"
              v-if="buttonTwoValue"
            >
              <span>{{buttonTwoValue}}</span>
            </button-style-component>
            <!--<div class="button-style-div button-one-div" v-html="buttonOneValue" @click="buttonOne"></div>-->
            <!--<div class="button-style-div button-two-div" v-html="buttonTwoValue" @click="buttonTwo"></div>-->
          </div>
        </div>
    </div>
</template>

<script>
    import ButtonStyleComponent from "./buttonStyleComponent";

    export default {
      components: {ButtonStyleComponent},
      name: "dialog-component",
      data(){
          return{
            initStatus:"hidden",
            showHide:0,
            mouseObj:{
              mouseDownStatus:false,
              mouseDownX:0,
              mouseDownY:0,
              mouseDownDialogX:0,
              mouseDownDialogY:0,
              popX:0,
              popY:0
            },
          }
      },
      computed:{
        dialogData:function () {// dialogData 数据
          return this.$store.state.dialogData.dialogObj;
        },
        shadeShow:function () {//控制 背景遮罩 的 显示与否
          $('#focusInput').click();
          $('#focusInput').focus();

          return this.$store.state.dialogData.dialogObj.shadeShow;
        },
        dialogShow:function () {// 控制dialog 显示与否
          return this.$store.state.dialogData.dialogObj.dialogShow;
        },
        dialogDisplayContent:function () {// dialog 显示内容
          return this.$store.state.dialogData.dialogObj.dialogDisplayContent;
        },
        buttonOneValue:function () {// button one 显示内容
          return this.$store.state.dialogData.dialogObj.buttonOne.value;
        },
        buttonTwoValue:function () {// button two 显示内容
          return this.$store.state.dialogData.dialogObj.buttonTwo.value;
        },
        dialogHead:function () {
          return this.$store.state.dialogData.dialogObj.dialogHead;
        }
      },
      beforeMount:function () {
        var self = this;
        setTimeout(function () {
          self.initStatus = "visible";
        },300);
      },
      mounted:function(){
        var _self = this;
        setTimeout(function () {
          _self.showHide = 1;
        },1000);

        this.dealDialogSite();
      },
      methods:{
          //执行 button one 的事件 方法
        buttonOne:function (e) {
          if(e){
            if(e.keyCode == 13){
              this.$store.dispatch("runButtonOneCallBack");
            }else if(e.keyCode == 27){
              this.$store.dispatch("dialogClose");
            }
          }else{
            this.$store.dispatch("runButtonOneCallBack");
          }
        },
        //执行 button two 的事件 方法
        buttonTwo:function () {
          this.$store.dispatch("runButtonTwoCallBack");
        },
        closeDialog:function () {
          this.$store.dispatch("dialogClose");
        },
        dealDialogSite:function () {
          let w=400,h=167;
          if(this.$el && this.$el.children && this.$el.children[1]){
            w=this.$el.children[1].offsetWidth;
            h=this.$el.children[1].offsetHeight;
          }

          var widthV = window.innerWidth;
          this.mouseObj.popX = (widthV - w)/2+"px";
          var heightV = window.innerHeight;
          this.mouseObj.popY = (heightV - h)/2+"px";
        }
      }
    }
</script>

<style scoped>
  .dialog-pop-win-div{
    width: 400px;
    background-color: white;
    border-radius: 10px;
    box-sizing: border-box;
    overflow: hidden;
    position: absolute;
  }
  .dialog-content-div{
    min-height: 80px;
    font-size: 16px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    padding: 0 10px;
    box-sizing: border-box;
    justify-content: center;
    max-height:400px;
    overflow-y:auto;
    overflow-x: hidden;
  }
  .dialog-button-div{
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin-bottom: 20px;
  }

  .close-size{
    font-size: 20px;
  }
  .dialog-head-div{
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 36px;
    background-color: #f5f6fa;
    padding: 0 10px;
    cursor: move;
  }
  .dialog-head-div span{
    color: white;
    font-size: 16px;
  }
  .close-button{
    color: #666666;
    cursor: pointer;
    transform: rotate(0deg);
    transition: all 0.2s linear;
  }
  .close-button:hover{
    transform: rotate(180deg);
  }

  .hide-shade{
    animation: hideShade 0.2s ease-in-out forwards;
  }
  @keyframes hideShade {
    0%{
      opacity: 1;
    }
    99%{
      opacity: 0;
      transform: scale(1);
    }
    100%{
      transform: scale(0);
    }
  }
  .show-shade{
    animation: showShade 0.2s ease-in-out forwards;
  }
  @keyframes showShade {
    0%{
      opacity: 0;
      transform: scale(0);
    }
    1%{
      transform: scale(1);
    }
    100%{
      opacity: 1;
      transform: scale(1);
    }
  }
  .hide-scale{
    animation: hideScale 0.2s ease-in-out forwards;
  }
  @keyframes hideScale {
    0%{
      transform: scale(1);
    }
    100%{
      transform: scale(0);
    }
  }

  .show-scale{
    animation: showScale 0.2s ease-in-out forwards;
  }
  @keyframes showScale {
    0%{
      transform: scale(0);
    }
    100%{
      transform: scale(1);
    }
  }

  .get-focus-input{
    border:none;
    background-color: rgba(0,0,0,0)
  }

  .load-img-div{
    width: 100px;
    height: 100px;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-left: -50px;
    margin-top: -50px;
    background-color: white;
    padding: 10px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
  }
  .img-log-style{
    width: 80px;
    height: 80px;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/dialogComponent.vue